import moment from 'moment';
import { DateFormats } from 'UI/constants/defaults';

import { COMPLETED_TASKS_STORAGE_KEY, TEAM_FILTERS_STORAGE_KEYS } from './DailyPlan.constants';

const getStartDate = (date, isOnlyDate) => {
  return isOnlyDate
    ? moment.parseZone(date).format(DateFormats.MonthDayYear)
    : moment(date).format(DateFormats.MonthDayYearTime);
};

export const formatResponse = response => {
  const formattedData = response.data.data.map(item => ({
    ...item,
    phoneNumbers: {
      phone: item?.phone,
      phones: item?.phones
    },
    taskType: item?.customTask ? `${item.taskType} - ${item.customTask}` : item?.taskType,
    taskStatus: {
      id: item?.taskStatusId,
      name: item?.taskStatus
    },
    company: {
      id: item?.companyId ?? null,
      name: item?.company ?? null
    },
    contact: {
      entityType: item?.entityType ?? null,
      entityTypeId: item?.entityTypeId ?? null,
      fullName: item?.contactName ?? null,
      id: item?.contactId ?? item?.entityId ?? null,
      entityTypeCode: item.entityTypeCode ?? null
    },
    startDate: item?.startDatetime
      ? getStartDate(item?.startDatetime, item?.startDatetimeIsOnlyDate)
      : null,
    communicationData: {
      email: item?.email,
      phone: item?.phone
    },
    outcome: item?.customOutcome ? `${item?.outcome} - ${item.customOutcome}` : item?.outcome
  }));

  return { ...response, data: { ...response.data, data: formattedData } };
};

export const getInitialTeamFilters = () => {
  const savedCoach = localStorage.getItem(TEAM_FILTERS_STORAGE_KEYS.DAILY_PLAN_COACH);
  const savedRecruiter = localStorage.getItem(TEAM_FILTERS_STORAGE_KEYS.DAILY_PLAN_RECRUITER);

  const initialFilters = {};

  if (savedCoach) {
    initialFilters.coach = {
      paramName: 'coachIds',
      value: JSON.parse(savedCoach)
    };
  }

  if (savedRecruiter) {
    initialFilters.recruiter = {
      paramName: 'assignedTo',
      value: JSON.parse(savedRecruiter)
    };
  }

  return initialFilters;
};

export const persistTeamSelectors = teamFilters => {
  if (teamFilters?.coach?.value) {
    localStorage.setItem(
      TEAM_FILTERS_STORAGE_KEYS.DAILY_PLAN_COACH,
      JSON.stringify(teamFilters?.coach?.value)
    );
  }

  if (teamFilters?.recruiter?.value) {
    localStorage.setItem(
      TEAM_FILTERS_STORAGE_KEYS.DAILY_PLAN_RECRUITER,
      JSON.stringify(teamFilters?.recruiter?.value)
    );
  }
};

export const getShowCompletedTasksCheckFromStorage = () => {
  const value = localStorage.getItem(COMPLETED_TASKS_STORAGE_KEY);
  return value ? JSON.parse(value) : true;
};
